import React from "react";
import { Box, Typography, styled } from "@mui/material";
import { imageList } from "../assets/images";
import maintenaceImg from "../assets/maintance.png";

interface ImageList {
  [key: string]: string;
}

// Styled components for a more organized layout
const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  backgroundColor: "#fff",
  height: '100svh'
}));

const Header = styled(Typography)(({ theme }) => ({
  fontSize: "4.5rem",
  color: "#037E82",
  // lineHeight:1,
  [theme.breakpoints.down('md')]: {
    fontSize: "2.1rem",
  },
}));

const SubHeader = styled(Typography)(({ theme }) => ({
  fontSize: "1.1rem",
  // lineHeight:1,
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    fontSize: "0.9rem",
  },
}));

const MaintenanceText = styled(Typography)(({ theme }) => ({
  fontSize: "1.4rem",
  color: "#02906F",
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: "1.2rem",
  },
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height:'40%'
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: 25,
  top: 15,
  [theme.breakpoints.down('md')]: {
    position: "relative",
    marginBottom: theme.spacing(2),
    top: 10,
    left: 0,
  }
}))

const MaintenanceImage = styled('img')(({ theme }) => ({
  objectFit: "cover",
  height:'100%',
  [theme.breakpoints.down('md')]: {
    width: '85%'
  }
}))



//*************************  system maintenace start  ***********************************/ 

const SystemMaintenance = () => {
  return (
    <StyledContainer>
      {/* <LogoContainer>
        <img
          src={(imageList as ImageList)["logo"]}
          alt="Logo"
          style={{
            verticalAlign: "middle",
            borderRadius: "50%",
            objectFit: "cover",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        />
      </LogoContainer> */}
      <Header>Manage My Moves</Header>
      <SubHeader>
        The bespoke Removal & Storage Cloud Software Platform <br />
        Built by Removers, for Removers
      </SubHeader>
      <ImageContainer>
        <MaintenanceImage
          src={maintenaceImg}
          alt="Maintenance"
        />
      </ImageContainer>
      <MaintenanceText>
        Attention, fellow logisticans! Our digital gears are getting a tune-up.
        ⚙️ <br />
        During this brief pit stop, expect smoother routes ahead! We'll be back
        on track in no time!
      </MaintenanceText>
    </StyledContainer>
  );
};

export default SystemMaintenance;
